import Vue from 'vue';
import Component from 'vue-class-component';

import LoggedUser from 'assets/graphql/queries/LoggedUser.graphql';
import RemindersRegalendario from 'assets/graphql/queries/RemindersList.graphql';
import OnboardingRegalendario from 'components/Reminders/OnboardingRegalendarioModal/OnboardingRegalendarioModal.vue';
import RemindersQuitModal from 'components/Reminders/RemindersQuitModal/RemindersQuitModal.vue';
import Reminders from 'components/Modals/Reminders/Reminders.vue';
@Component({
  apollo: {
    logged_user: LoggedUser,
    reminders: {
      query: RemindersRegalendario,
      skip() {
        return !this.logged_user;
      },
      update(data) {
        this.remindersComplete = data.reminders.length >= 3;
        return data.reminders;
      },
    },
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    cta: {
      type: String,
      required: true,
    },
    remindersModalView: {
      type: Boolean,
      default: false,
    },
    showReminderOnboarding: {
      type: Boolean,
    },
  },
  components: {
    Reminders,
    RemindersQuitModal,
    OnboardingRegalendario,
  },
})
export default class CardHomeComponent extends Vue {
  steps = ['first', 'second', 'third', 'final'];
  remindersComplete = null;
  saveOrContinueModal = false;
  onboard = true;

  handleRemindersModalView() {
    if (this.logged_user) {
      this.$emit('toggleRemindersModalView', !this.remindersModalView);
      this.toggleOnboarding(false);
    } else {
      this.$router.push({
        name: 'login',
      });
    }
  }

  toggleOnboarding(status) {
    this.$emit('toggleOnboarding', status);
  }

  handleSaveOrContinueModal(action) {
    switch (action) {
      case 'show':
        if (this.remindersComplete) {
          this.handleRemindersModalView();
        } else {
          this.handleRemindersModalView();
          this.saveOrContinueModal = true;
        }
        break;
      case 'save':
        this.saveOrContinueModal = false;
        break;
      case 'close':
        this.handleRemindersModalView();
        this.saveOrContinueModal = false;
        break;
    }
  }

  nextStep() {
    this.$apollo.queries.reminders.refetch();
  }

  get viewStep() {
    if (this.remindersComplete) {
      return 'final';
    } else {
      return this.reminders?.length
        ? this.steps[this.reminders?.length]
        : 'first';
    }
  }
}
